import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

import { TRANSPARENT_LOGO } from "@/lib/brand";
const LOGO = TRANSPARENT_LOGO;

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await login(email, password); nav("/admin"); toast.success("Welcome, proprietor"); }
    catch { toast.error("Invalid credentials"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-forest" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8"><img src={LOGO} alt="" className="h-28 mx-auto" /></div>
        <div className="curio-card corner-frame p-8">
          <h1 className="font-display text-2xl text-gold text-center mb-6">Proprietor's Ledger</h1>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="font-caption text-[10px] text-brass block mb-1">Email</label>
              <input data-testid="admin-email-input" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-vintage" />
            </div>
            <div>
              <label className="font-caption text-[10px] text-brass block mb-1">Password</label>
              <input data-testid="admin-password-input" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-vintage" />
            </div>
            <button data-testid="admin-login-submit" disabled={loading} className="btn-gold w-full">{loading ? "..." : "Sign In"}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
